import React from 'react';

const NotFoundPage = () => (
  <section className="site-page">
    <header className="site-page--header">
      <h1 className="site-page--title">Oooops!</h1>
    </header>
    <p>The page you are looking for does not exist.</p>
  </section>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js